/// <amd-module name="Feed/Legacy/Protocols/NuGet/NuGetOverviewContentPanel" />
import * as React from "react";

import * as Utils_String from "VSS/Core/Util/String";

import { CiConstants } from "Feed/Common/Constants/Constants";
import * as PackageResources from "Feed/Common/Resources";
import { ConnectToFeedButton } from "Feed/Legacy/Components/ConnectToFeedButton";
import { IPackageDetailsProps } from "Feed/Legacy/Protocols/Common/IPackageDetailsProps";
import { IPackageProtocol } from "Feed/Legacy/Protocols/Common/IPackageProtocol";
import { CopyableTextField, ICopyableTextFieldTelemetry } from "Feed/Legacy/Protocols/Components/CopyableTextField";
import { PackageTile } from "Feed/Legacy/Protocols/Components/PackageTile";
import { INuGetProtocolMetadata } from "Feed/Legacy/Protocols/NuGet/NuGetProtocolMetadata";
import { HubAction } from "Feed/Legacy/Types/IHubState";

export class NuGetOverviewContentPanel extends React.PureComponent<IPackageDetailsProps> {
    public render(): JSX.Element {
        const { packageVersion, protocol, packageSummary, feed } = this.props;

        const nugetMetadata: INuGetProtocolMetadata =
            packageVersion.protocolMetadata && packageVersion.protocolMetadata.data
                ? (packageVersion.protocolMetadata.data as INuGetProtocolMetadata)
                : null;

        const protocolMap: { [key: string]: IPackageProtocol } = {};
        protocolMap[protocol.name] = protocol;
        const textfieldId = "nuget-overview-textfield-label1";

        const command = protocol.getCopyInstallCommand(feed, packageSummary.name, packageVersion);
        const installCmd = Utils_String.format(
            "{0} {1}",
            PackageResources.NuGet_InstallInstructions_InstallPackageCommand_Client,
            command
        );

        return (
            <div className="package-overview-content-panel">
                {!packageVersion.isDeleted && (
                    <PackageTile title={PackageResources.NuGet_InstallInstructions_Title} id={textfieldId}>
                        <div className="get-package-tile">
                            <ConnectToFeedButton
                                pageContext={this.props.pageContext}
                                feed={feed}
                                feedViews={this.props.feedViews}
                                protocolMap={protocolMap}
                                hubAction={HubAction.Package}
                            />
                            <span className="install-instructions-then">
                                {PackageResources.InstallInstructions_then}
                            </span>
                            <CopyableTextField
                                pageContext={this.props.pageContext}
                                displayText={installCmd}
                                text={command}
                                buttonAriaLabel={PackageResources.AriaLabel_CopyToClipBoard_Nuget_Install_Copy}
                                textFieldAriaLabel={PackageResources.AriaLabel_CopyToClipBoard_Nuget_Install}
                                telemetryProperties={
                                    {
                                        commandName: CiConstants.CopyCommandInstall,
                                        feedName: feed.name,
                                        packageName: packageSummary.name,
                                        packageVersion: packageVersion.version,
                                        protocol: protocol.name
                                    } as ICopyableTextFieldTelemetry
                                }
                                ariaDescribedByIdForLabelText={textfieldId}
                            />
                        </div>
                    </PackageTile>
                )}
                <PackageTile title={PackageResources.NuGet_Description_Title}>
                    <div className="package-description">{packageVersion.description}</div>
                    {nugetMetadata && nugetMetadata.releaseNotes && (
                        <div>
                            <div className="package-group-spacer" />
                            <div className="package-group-header" role="heading" aria-level={3}>
                                {PackageResources.NuGetReleaseNotes_Title}
                            </div>
                            {nugetMetadata.releaseNotes.split(/\r\n|\r|\n/g).map((line, index) => {
                                return <div key={"ReleaseNote_Key_" + index}>{line}</div>;
                            })}
                        </div>
                    )}
                </PackageTile>
            </div>
        );
    }
}
